export default "__VITE_ASSET__6d3bb33e__"